import React from 'react';
import { updateSpace } from '../../app-main/actions/space';
import { SubmissionError } from 'redux-form';
import { push } from 'react-router-redux';
import { mapValues, filter, get, pick, find } from 'lodash';
import { productionQuestions } from '../data/utils';
import { FormattedMessage } from 'react-intl';

const onSubmitProductionForm = (values = {}, dispatch, props) => {
  const { spaceId, accessToken, nextPage } = props;

  const payload = {};
  payload.production_details = {
    ...mapValues(values, (val, key) => {
      if (('true' === val) || ('false' === val)) {
        return 'true' === val;
      }

      if ('space_access_types' === key) {
        return filter(val, type => !!type);
      }

      return val;
    })
  };

  const errorMessage = <FormattedMessage id="hosting.on_submit_production_forms.error_message" defaultMessage="Submission failed. Please refresh and try again." />;
  const page = get(props, 'page');
  const productionKeys = get(productionQuestions, [page], {});
  const analyticsPayload = {
    space_id: spaceId,
    page,
    ...(pick(payload.production_details, productionKeys.keys))
  };

  return dispatch(updateSpace(spaceId, accessToken, payload))
    .then(() => {
      analyticsIntegrations.productionQuestions(analyticsPayload);
      // direct user to listing TOC
      const listings = get(props, 'listings.data', []);
      const productionListing = find(listings, listing => {
        return 'Production' === listing.use_type;
      }) || {};

      if ('mylistings' === nextPage) {
        return dispatch(push(`/mylistings/${productionListing._id}`));
      }

      return dispatch(
        push(`/your-space/${spaceId}/production-faqs/${nextPage}`),
      );
    })
    .catch((error) => {
      throw new SubmissionError({ _error: error || errorMessage });
    });
};

export default onSubmitProductionForm;
